import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  ({ palette, spacing }) => ({
    root: {
      width: '100%',
    },
    title: {
      color: palette.primary.contrastText,
      margin: `${spacing(0, 2, 0, 0)} !important`,
      whiteSpace: 'nowrap',
    },
    headerWrap: {
      marginBottom: spacing(3),
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
    bodyWrap: {},
  }),
  { name: 'MyBusiness' },
);

export default useStyles;
